<template>
  <v-footer class="footer-neo py-12 py-md-14">
    <v-container>
      <div class="footer-top">
        <div class="footer-brand">
          <img :src="logoUrl" alt="LINQFORCE Logo" class="footer-logo" width="192" height="56" loading="lazy" decoding="async" />
        </div>

        <div class="footer-col">
          <div class="footer-title">{{ t('footer.products.title') }}</div>
          <nav class="footer-links" :aria-label="locale === 'en' ? 'Product links' : 'Produktlinks'">
            <a :href="navHref('problems')" @click.prevent="nav('problems')">{{ t('footer.products.solutions') }}</a>
          </nav>
        </div>

        <div class="footer-col">
          <div class="footer-title">{{ t('footer.company.title') }}</div>
          <nav class="footer-links" :aria-label="locale === 'en' ? 'Company links' : 'Unternehmenslinks'">
            <a :href="navHref('core')" @click.prevent="nav('core')">{{ t('footer.company.about') }}</a>
            <a :href="navHref('blog')" @click.prevent="nav('blog')">{{ t('footer.company.blog') }}</a>
            <a :href="navHref('faq')" @click.prevent="nav('faq')">{{ t('footer.company.faq') }}</a>
            <a :href="navHref('career')" @click.prevent="nav('career')">{{ t('footer.company.career') }}</a>
            <a :href="navHref('contact')" @click.prevent="nav('contact')">{{ t('footer.company.contact') }}</a>
          </nav>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="footer-copy">{{ t('footer.copy', { year }) }}</div>
        <nav class="footer-legal" :aria-label="locale === 'en' ? 'Legal links' : 'Rechtliche Links'">
          <RouterLink to="/impressum">{{ t('footer.legal.imprint') }}</RouterLink>
          <RouterLink to="/datenschutz">{{ t('footer.legal.privacy') }}</RouterLink>
          <RouterLink to="/barrierefreiheit">{{ t('footer.legal.accessibility') }}</RouterLink>
          <a href="/datenschutz#cookie-einstellungen" @click.prevent="openConsent">{{ t('footer.legal.cookies') }}</a>
        </nav>
      </div>
    </v-container>
  </v-footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

type FooterAnchor = 'problems' | 'core' | 'blog' | 'career' | 'contact' | 'faq'

defineProps<{
  logoUrl: string
  locale: string
  year: number
}>()

const emit = defineEmits<{
  nav: [anchor: FooterAnchor]
  'open-consent': []
}>()

const { t } = useI18n()

function navHref(anchor: FooterAnchor) {
  return `/#${anchor}`
}

function nav(anchor: FooterAnchor) {
  emit('nav', anchor)
}

function openConsent() {
  emit('open-consent')
}
</script>
